import React, { Component } from 'react';
import animations from './animations';
import Heading from '../../elements/Heading';

class InlineTextBlocks extends Component {

    componentDidUpdate() {
        if (this.props.dataReceived) {
            animations.initialise(this);
        }
    }

    render() {
        let Items;
        if (this.props.data.items) {
            Items = this.props.data.items.map((item, key) => {
                const Description = item.descriptions.map((desc, key) => {
                    return (
                        <p key={key} dangerouslySetInnerHTML={{__html: desc}} />
                    );
                });

                return (
                    <div key={key} className="column">
                        <h3 dangerouslySetInnerHTML={{__html: item.title}} />
                        {Description}
                    </div>
                );
            });
        }

        let Copy;
        if (this.props.data.copy) {
        	Copy = this.props.data.copy.map((value, key) => {
				return (
					<p key={key} dangerouslySetInnerHTML={{__html: value}} />
				);
			});
		}

        return (
            <section className="inline-text-blocks">
                <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-xs-12 centered">
                        <Heading title={this.props.data.title} subTitle={this.props.data.subTitle} />
						{Copy}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 centered">
                        <div className="columns">
                            {Items}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
    
}

export default InlineTextBlocks;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/InlineTextBlocks/InlineTextBlocks.js